$('.pp-connect-mail').each(function() {
    let $self = $(this);
    let $form = $(this).find('form');
    let $formGroup = $form.children('.form-group');
    let $input = $formGroup.find('input[name=email]');
    let $note = $formGroup.find('input[name=note]');

    $formGroup.removeClass(['has-error', 'has-success']);
    $self.removeClass('has-success');

    $form.on('submit', function(e) {
        e.preventDefault();

        $.post('/subscribe-email', {
            email: $input.val(),
            note: $note.length > 0 ? $note.val() : ''
        }).success(function(result) {
            if (result && result.status == 'success') {
                $self.addClass('has-success');

                dataLayer.push({
                    'event':     'ga.event',
                    'eCategory': $('body').data('ga-category') || 'Neznámá',
                    'eAction':   'Přihlášení',
                    'eLabel':    'Newsletter'
                });
                return;
            }

            $formGroup.addClass('has-error');

            if (result && result.message) {
                $formGroup.find('.form-message-error').html(result.message);
            }

        }).error(function() {
            $formGroup.addClass('has-error');
        })
    });
});



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/ppConnectMail.js